// D294: endless CSS animations stop where nobody can see them.
//
// The landing page runs four of them forever — the coin's glow (a `filter`, so a repaint every
// frame), the Play button's sheen (a `background-position`, the same) and the five floating
// renders' bob — and a running animation keeps the page producing frames at the display's rate
// even when the element has been scrolled away. This marks each one `data-offscreen` while it
// is outside the viewport; the stylesheet pauses a marked element ONLY while the root carries
// `data-saver-css` (the `cssOffscreen` power saver), so the switch lives in one attribute and
// this observer never needs to know whether it is on.
//
// Without IntersectionObserver (jsdom, old Safari) nothing is ever marked, which is the
// pre-D294 behaviour: every animation simply runs.

/** The root attribute the stylesheet keys the CSS saver on. */
export const CSS_SAVER_ATTR = 'data-saver-css';

/** Mark each element `data-offscreen` while it is out of view. Returns the disconnect. */
export function pauseWhileOffscreen(els: readonly Element[]): () => void {
  if (typeof IntersectionObserver !== 'function' || els.length === 0) return () => undefined;
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) e.target.toggleAttribute('data-offscreen', !e.isIntersecting);
  });
  for (const el of els) io.observe(el);
  return () => {
    io.disconnect();
    for (const el of els) el.removeAttribute('data-offscreen');
  };
}

/** Turn the CSS saver on or off for the whole document. */
export function applyCssSaver(doc: Document, on: boolean): void {
  doc.documentElement.toggleAttribute(CSS_SAVER_ATTR, on);
}
